import type { GetServerSidePropsContext } from 'next'
import { fetchWithPolicy } from '../shared/api/fetchPolicy'

export const joinPath = (segments: string[]) => {
  if (!segments.length) return '/'
  return `/${segments.join('/')}`.replace(/\/{2,}/g, '/')
}

export const buildSearchFromQuery = (query: Record<string, unknown>): string => {
  const searchParams = new URLSearchParams()

  Object.entries(query).forEach(([key, value]) => {
    if (key === 'slug') return
    if (Array.isArray(value)) {
      value.forEach((item) => {
        if (item != null) searchParams.append(key, String(item))
      })
      return
    }
    if (value != null) searchParams.append(key, String(value))
  })

  return searchParams.toString() ? `?${searchParams.toString()}` : ''
}

export const resolveOrigin = (ctx: GetServerSidePropsContext) => {
  const forwardedProto = (ctx.req.headers['x-forwarded-proto'] as string | undefined)?.split(',')[0]
  const protocol = forwardedProto || 'http'
  const host = ctx.req.headers.host || 'localhost:3000'
  return `${protocol}://${host}`
}

export const resolveApiBase = (origin: string) => {
  const internal = process.env.SHOP_INTERNAL_API_URL?.trim()
  if (internal) return internal.replace(/\/+$/, '')

  const raw = (process.env.NEXT_PUBLIC_API_URL || '/api').trim()
  if (/^https?:\/\//i.test(raw)) return raw.replace(/\/+$/, '')
  const normalizedPath = raw.startsWith('/') ? raw : `/${raw}`
  return `${origin}${normalizedPath}`.replace(/\/+$/, '')
}

export const fetchJson = async (url: string) => {
  const response = await fetchWithPolicy({
    request: url,
    retries: 0,
  })
  const text = await response.text()
  let json: Record<string, unknown> = {}

  if (text) {
    try {
      json = JSON.parse(text) as Record<string, unknown>
    } catch {
      json = {}
    }
  }

  return { ok: response.ok, status: response.status, data: json }
}
